function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle",
  fill: "none",
  stroke: "#e4e9ee",
  strokeMiterlimit: 10,
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 180,
  height: 55,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 179,
  height: 54,
  rx: 4.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "Download_iMac-2",
  "data-name": "Download iMac",
  transform: "translate(48 35)",
  fill: "#0b2136",
  fontSize: 15,
  fontFamily: "SegoeUI, Segoe UI"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Download iMac"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Apple_logo_black",
  transform: "translate(20 17)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M3.861,20.477C-1.925,14.52-1.071,5.445,5.505,5.1c1.595.085,2.712.882,3.651.949,1.4-.284,2.733-1.1,4.228-.991A5.151,5.151,0,0,1,17.42,7.189a4.693,4.693,0,0,0,.574,8.455,12.021,12.021,0,0,1-3.01,4.847l0-.015a3.039,3.039,0,0,1-3.651.418,4.626,4.626,0,0,0-3.843,0,4.477,4.477,0,0,1-1.743.441A2.7,2.7,0,0,1,3.861,20.477ZM9.029,5.039A4.861,4.861,0,0,1,13.469,0,4.8,4.8,0,0,1,9.338,5.065,1.75,1.75,0,0,1,9.029,5.039Z",
  transform: "translate(0.004)",
  fill: "#0b2136"
}));

function SvgImac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_iMac",
    "data-name": "Download iMac",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 55,
    viewBox: "0 0 180 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImac);
export default __webpack_public_path__ + "static/media/imac.6ed5b254.svg";
export { ForwardRef as ReactComponent };